formValidation = {
  init: function init() {},
  validateForm: function validateForm(form) {
    formValidation.clearAllErrors(form);
    var invalidInputs = [];
    $.each($(form).find('.form-group'), function (i, item) {
      var input = $(item).find('input').first();
      var textarea = $(item).find('textarea').first();
      if (input && input.attr('type') == 'text' || input.attr('type') == 'email') {
        if (!formValidation.validateInput(input)) {
          formValidation.showErrors(item);
          invalidInputs.push(input);
        }
      } else if (textarea && textarea.attr('required')) {
        if (!formValidation.validateInput(textarea)) {
          formValidation.showErrors(item);
          invalidInputs.push(textarea);
        }
      }
    });
    return invalidInputs;
  },
  validateInput: function validateInput(input) {
    if (!formValidation.validatRequiredInput(input)) {
      return false;
    }
    if (input.attr('type') == 'email') {
      if (!formValidation.validateEmailInput($(input).val())) {
        return false;
      }
    }
    return true;
  },
  validatRequiredInput: function validatRequiredInput(input) {
    if (!input.attr('required') || $(input).val()) {
      return true;
    }
    return false;
  },
  validateEmailInput: function validateEmailInput(email) {
    var pattern = new RegExp(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/);
    return pattern.test(email);
  },
  showErrors: function showErrors(input) {
    $(input).addClass('has-error');
    $(input).find('.help-block').show();
  },
  clearAllErrors: function clearAllErrors(form) {
    $(form).find('.has-error').removeClass('has-error');
    $(form).find('.help-block').hide();
  }
};